import accounts from '../props/accounts';
import { default as accountBuilder } from './accountBuilder.js';

// TODO: Add more accounts and dynamic functionality for paging / search

export const getAccountPagePageStub = (_body, url = '') => {
	const searchParams = new URLSearchParams(url);
	const paymentType = decodeURIComponent(searchParams.get('paymentType') || '');
	const accountNumber = decodeURIComponent(searchParams.get('accountNumber') || '');
	const sortCode = decodeURIComponent(searchParams.get('sortCode') || '');
	const search = searchParams.get('search');

	let lcvAccounts = accounts.map((account) => ({
		...account,
		actions_available: account.actionsAvailable,
	}));

	// let lcvAccounts = accountBuilder;

	if (paymentType) {
		const paymentTypes = paymentType.split(',');
		lcvAccounts = lcvAccounts.filter((account) =>
			paymentTypes.some((paymentType) => account.actions_available[paymentType])
		);
	}
	if (accountNumber && sortCode) {
		lcvAccounts = lcvAccounts.filter(
			(account) => accountNumber.includes(account.accountNumber) && sortCode.includes(account.sortCode)
		);
	}

	if (search) {
		const searchRegEx = new RegExp(search.toLowerCase(), 'gi');
		lcvAccounts = lcvAccounts.filter(
			(account) =>
				searchRegEx.test(account.displayName) ||
				searchRegEx.test(account.accountName) ||
				(account.metadata && account.metadata.account_name && searchRegEx.test(account.metadata.account_name))
		);
	}

	return {
		accounts: lcvAccounts,
		total_matched_accounts: lcvAccounts.length,
		page_meta_data: {
			total_pages: lcvAccounts.length % 30,
			page_number: 1,
			// this is to make it more reflective of the actual API response
			search_account_number: accountNumber || '',
			search_sort_code: sortCode || '',
			search_text: search || '',
			total_elements: lcvAccounts.length,
		},
	};
};
